// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pgrid-error-msg[data-v-4555bdb9]{color:red}", "",{"version":3,"sources":["webpack://./src/lib/pgrid/pgrid-filter-chooser.vue"],"names":[],"mappings":"AAAA,kCAAkC,SAAS","sourcesContent":[".pgrid-error-msg[data-v-4555bdb9]{color:red}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
